<template>
    <div class="qingwu">
        <div class="admin_main_block">
            <div class="admin_main_block_top">
                <div class="admin_main_block_left">

                    <div><el-input v-model="where.F_VR_XINGMING" placeholder="请输入学员姓名"></el-input></div>
                    <div><el-button icon="el-icon-search" @click="get_adv_list()">条件筛选</el-button></div>
                </div>

                <div class="admin_main_block_right">
                    <div><el-button type="danger" icon="el-icon-delete" @click="del(select_id)">批量删除</el-button></div>
                </div>
            </div>
            <div class="admin_table_main">
                <el-table :data="list" @selection-change="handleSelectionChange" >
                    <el-table-column type="selection"></el-table-column>
                    <!-- <el-table-column prop="id" label="#" fixed="left" width="70px"></el-table-column> -->
                    <el-table-column prop="F_IN_ID" label="#"  width="50px"></el-table-column>
                    <el-table-column prop="F_VR_XINGMING" label="学员姓名" width="70px"></el-table-column>
                    <el-table-column prop="F_IN_NIANLING" label="学员年龄" width="70px"></el-table-column>
                    <el-table-column label="学员性别" width="70px">
                        <template slot-scope="scope">
                            <el-tag type="success" v-if="scope.row.F_TI_SEX==1">男</el-tag>
                            <el-tag type="danger" v-else-if="scope.row.F_TI_SEX==2">女</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="F_VR_JIAZXM" label="家长姓名" width="70px"></el-table-column>
                    <el-table-column prop="F_VR_LIANXDH" label="联系电话"></el-table-column>
                    <el-table-column prop="F_IN_JIDID" label="基地" width="80px"></el-table-column>
                    <el-table-column prop="F_IN_YINGQ_ID" label="营期" width="100px"></el-table-column>
                    <el-table-column prop="F_IN_YINGQQX_ID" label="期数" width="60px"></el-table-column>
                    <el-table-column prop="F_VR_ZSLS" label="招生老师" width="70px"></el-table-column>
                    <el-table-column prop="F_VR_ZONGJG" label="总价格" width="60px"></el-table-column>
                    <el-table-column label="支付状态" width="75px">
                        <template slot-scope="scope">
                            <el-tag type="success" v-if="scope.row.F_TI_ZHIF==1">已支付</el-tag>
                            <el-tag type="danger" v-else-if="scope.row.F_TI_ZHIF==2">未支付</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="out_trade_no" label="商户订单号" ></el-table-column>
                    <el-table-column prop="adv_start" label="创建时间">
                        <template slot-scope="scope">
                            <div v-if="scope.row.F_IN_CHUANGJSJ<=0"> - </div>
                            <div v-else>{{scope.row.F_IN_CHUANGJSJ|formatDate}}</div>
                        </template>
                    </el-table-column>

                    <el-table-column label="操作" fixed="right" width="120px">
                        <template slot-scope="scope">
                            <el-button icon="el-icon-edit" @click="$router.push('/Admin/zaixbm/info/'+scope.row.F_IN_ID)">查看详情</el-button>
                            <!-- <el-button type="danger" icon="el-icon-delete" @click="del(scope.row.id)">删除</el-button> -->
                        </template>
                    </el-table-column>
                </el-table>
                <div class="admin_table_main_pagination">
                    <el-pagination @current-change="current_change" background layout="prev, pager, next,jumper,total" :total="total_data" :page-size="page_size" :current-page="current_page"></el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    props: {},
    data() {
      return {
          list:[],
          total_data:0, // 总条数
          page_size:20,
          current_page:1,
          select_id:'',
          adv_position_id:0,
          where:{
              F_VR_XINGMING:'',
          },
      };
    },
    watch: {},
    computed: {},
    methods: {
        handleSelectionChange:function(e){
            let ids = [];
            e.forEach(v => {
                ids.push(v.F_IN_ID);
            });
            this.select_id = ids.join(',');
        },
        get_adv_list:function(){
            this.where.page = this.current_page;
            this.$get(this.$api.getZaixbmList,this.where).then(res=>{
                this.page_size = res.data.per_page;
                this.total_data = res.data.total;
                this.current_page = res.data.current_page;
                this.list = res.data.data;
            })

        },
        // 删除处理
        del:function(F_IN_ID){
            if(this.$isEmpty(F_IN_ID)){
                return this.$message.error('请先选择删除的对象');
            }
            this.$post(this.$api.delZaixbm,{F_IN_ID:F_IN_ID}).then(res=>{
                if(res.code == 200){
                    this.get_adv_list();
                    return this.$message.success("删除成功");
                }else{
                    return this.$message.error("删除失败");
                }
            });
        },
        current_change:function(e){
            this.current_page = e;
            this.get_adv_list();
        },
    },
    created() {
        this.get_adv_list();
    },
    mounted() {}
};
</script>
<style lang="scss" scoped>
</style>